import { render, staticRenderFns } from "./LinhasFormulario.vue?vue&type=template&id=7067a6e8"
import script from "./LinhasFormulario.vue?vue&type=script&lang=js"
export * from "./LinhasFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports